import MuiMenuItem from '@mui/material/MenuItem';
import { ComponentProps } from 'react';

import { ChevronLeftDoubleIcon } from '@/components/icons/ChevronLeftDoubleIcon';
import { ChevronRightDoubleIcon } from '@/components/icons/ChevronRightDoubleIcon';

import { MenuItem, MenuItemProps } from './MenuItem';

interface SidebarCollapseToggleProps {
  isExpanded: boolean;
  isTooltipReady: boolean;
  onToggle: () => void;
  menuItemSxProps?: ComponentProps<typeof MuiMenuItem>['sx'];
  colorTheme?: MenuItemProps['colorTheme'];
}

export function SidebarCollapseToggle({
  isExpanded,
  isTooltipReady,
  onToggle,
  menuItemSxProps,
  colorTheme = 'dark',
}: SidebarCollapseToggleProps) {
  return (
    <MenuItem
      text={isExpanded ? 'Collapse' : 'Expand'}
      isActive={false}
      icon={
        isExpanded ? (
          <ChevronLeftDoubleIcon size={16} />
        ) : (
          <ChevronRightDoubleIcon size={16} />
        )
      }
      tooltipTitle="Expand menu"
      onClick={onToggle}
      variant={isExpanded ? 'large' : 'small'}
      showTooltip={Boolean(isTooltipReady && !isExpanded)}
      menuItemSxProps={{
        cursor: 'pointer',
        ...menuItemSxProps,
      }}
      colorTheme={colorTheme}
      typographyProps={{ variant: 'body-xs' }}
    />
  );
}
